"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var Mark_1 = __importDefault(require("./Mark"));

var marks = function marks(props) {
  var _a;

  var baseClassName = 'emankit__marks';
  var label = props.label,
      value = props.value,
      onChange = props.onChange;
  var cn = classnames_1.default("" + baseClassName, (_a = {}, _a[baseClassName + "--withoutLabel"] = !label, _a));

  var onMarkClick = function onMarkClick(event) {
    var mark = event.currentTarget.getAttribute('data-mark');

    if (mark) {
      onChange(parseInt(mark, 10));
    }
  };

  var smilesButtons = function smilesButtons() {
    var _a;

    var smiles = [];

    for (var i = 5; i >= 1; i--) {
      var active = i === value;
      var smileCn = classnames_1.default(baseClassName + "__mark", (_a = {}, _a[baseClassName + "__mark--active"] = active, _a));
      smiles.push(react_1.default.createElement("div", {
        className: smileCn,
        key: "mark-" + i,
        "data-mark": i,
        onClick: onMarkClick
      }, react_1.default.createElement(Mark_1.default, {
        mark: i,
        active: active
      })));
    }

    return smiles;
  };

  return react_1.default.createElement("div", {
    className: cn
  }, label && react_1.default.createElement("div", {
    className: baseClassName + "__title"
  }, react_1.default.createElement("label", null, label)), react_1.default.createElement("div", {
    className: baseClassName + "__marks"
  }, smilesButtons()));
};

exports.default = marks;